import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes for authentication, specifying paths using baseRoutes from the "helpers/baseRoutes" module.
 * Each route has a unique identifier and a corresponding path.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  LANDING: {
    path: `${baseRoutes.userBaseRoutes}`,
  },
  BLOGS: {
    path: `${baseRoutes.userBaseRoutes}/blogs`,
  },
  BLOGS_DETAIL: {
    path: `${baseRoutes.userBaseRoutes}/blog-details/:id`,
  },
  TERMS_AND_CONDITIONS: {
    path: `${baseRoutes.userBaseRoutes}/terms-and-conditions`,
  },
  PRIVACY_POLICY: {
    path: `${baseRoutes.userBaseRoutes}/privacy-policy`,
  },
};

export default accessRoute;
